import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function Configs() {
  const [propertyConfigs, setPropertyConfigs] = useState([]);
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredConfigs, setFilteredConfigs] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const propertyConfigRes = await fetch(
          "/dummy_data/property_config.json"
        );
        const projectRes = await fetch("/dummy_data/project.json");
        const propertyRes = await fetch("/dummy_data/property.json");
        const propertyConfigsData = await propertyConfigRes.json();
        const projectsData = await projectRes.json();
        const propertiesData = await propertyRes.json();

        const configWithProperties = propertyConfigsData.map((config) => {
          const propertyCount = config.propertiesId.length;
          return { ...config, propertyCount };
        });

        setPropertyConfigs(configWithProperties);
        setProjects(projectsData);
        setFilteredConfigs(configWithProperties);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    let configs = propertyConfigs;

    if (selectedProject) {
      configs = configs.filter(
        (config) => config.projectId === Number(selectedProject)
      );
    }

    if (searchTerm) {
      configs = configs.filter((config) =>
        config.configName.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredConfigs(configs);
  }, [selectedProject, searchTerm, propertyConfigs]);

  // Toggle Dropdown visibility
  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

  // Handle Project selection
  const handleProjectSelect = (projectId, projectName) => {
    setSelectedProject(projectId);
    setIsDropdownOpen(false); // Close dropdown after selection
  };

  return (
    <div className="p-8">
      <h1 className="text-2xl font-semibold mb-4">Project Configurations</h1>

      <div className="flex items-center space-x-4 mb-6">
        <input
          type="text"
          placeholder="Search configurations..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="p-2 border rounded-md w-1/3"
        />
        {/* Custom Dropdown */}
        <div className="relative w-32">
          <div
            onClick={toggleDropdown}
            className="p-2 border font-medium rounded-md cursor-pointer"
          >
            {selectedProject
              ? projects.find((project) => project.id === selectedProject)?.projectName
              : "All Projects"}
          </div>

          {/* Dropdown menu */}
          {isDropdownOpen && (
            <div className="absolute left-0 right-0 mt-1 bg-white border rounded-md shadow-lg z-20">
              <div
                onClick={() => handleProjectSelect("", "All Projects")}
                className="p-2 hover:bg-gray-200 cursor-pointer"
              >
                All Projects
              </div>
              {projects.map((project) => (
                <div
                  key={project.id}
                  onClick={() => handleProjectSelect(project.id, project.projectName)}
                  className="p-2 hover:bg-gray-200 cursor-pointer"
                >
                  {project.projectName}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Display "Not Found" message if no configs are available */}
      {filteredConfigs.length === 0 ? (
        <div className="text-center text-gray-500">No configurations found</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {filteredConfigs.map((config) => (
            <div
              key={config.id}
              className="border bg-white rounded-lg shadow p-4"
            >
              <img
                src={config.propertyConfigPictureUrl}
                alt={config.configName}
                className="h-40 w-full object-cover rounded-md mb-4"
              />
              <h2 className="text-lg font-semibold mb-4">{config.configName}</h2>

              <div className="space-y-2 p-2">
                {/* Carpet Area */}
                <div className="flex justify-between items-center">
                  <p className="text-gray-700 font-medium">Carpet Area:</p>
                  <p className="text-gray-700 font-normal">
                    {config.carpetArea} sq.ft.
                  </p>
                </div>

                {/* Base Price */}
                <div className="flex justify-between items-center">
                  <p className="text-gray-700 font-medium">Base Price:</p>
                  <p className="text-gray-700 font-normal">
                    ₹{config.basePrice.toLocaleString()}
                  </p>
                </div>

                {/* Properties */}
                <div className="flex justify-between items-center">
                  <p className="text-gray-700 font-medium">Properties:</p>
                  <p className="text-gray-700 font-normal">
                    {config.propertyCount}
                  </p>
                </div>
              </div>

              <button
                onClick={() =>
                  navigate(`/projects/${config.projectId}/configs/${config.id}`)
                }
                className="mt-4 py-2 bg-accent text-white w-full rounded-md"
              >
                View
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Configs;
